import React from 'react';

const ReferralWithdrawalFormModal = React.lazy(() => import('../components/FormModal'));
const referralWithdrawalModalRegistry = {
    core_referralWithdrawalId: ReferralWithdrawalFormModal
};
export default referralWithdrawalModalRegistry;
